import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addBadgesAsync,
  getAllBadgesAsync,
  getBadgesByIdAsync,
  updateBadgesByIdAsync,
  deleteBadgesByIdAsync,
} from "./badges.async";

const initialState = {
  streakBadgesLoader: false,
  addStreakBadges: [],
  getAllStreakBadges: [],
  getStreakBadgesById: [],
  streakBadgesUpdate: [],
  streakBadgesDelete: [],
};

export const streakBadgesSlice = createSlice({
  name: "streakBadges",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getAllBadgesAsync.pending,
        addBadgesAsync.pending,
        getBadgesByIdAsync.pending,
        updateBadgesByIdAsync.pending,
        deleteBadgesByIdAsync.pending
      ),
      (state) => {
        state.streakBadgesLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllBadgesAsync.fulfilled),
      (state, action) => {
        state.streakBadgesLoader = false;
        state.getAllStreakBadges = action.payload;
      }
    );
    builder.addMatcher(isAnyOf(addBadgesAsync.fulfilled), (state, action) => {
      state.streakBadgesLoader = false;
      state.addStreakBadges = action.payload;
    });
    builder.addMatcher(
      isAnyOf(getBadgesByIdAsync.fulfilled),
      (state, action) => {
        state.streakBadgesLoader = false;
        state.getStreakBadgesById = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(deleteBadgesByIdAsync.fulfilled),
      (state, action) => {
        state.streakBadgesLoader = false;
        state.streakBadgesDelete = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(updateBadgesByIdAsync.fulfilled),
      (state, action) => {
        state.streakBadgesLoader = false;
        state.streakBadgesUpdate = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getAllBadgesAsync.rejected,
        addBadgesAsync.rejected,
        getBadgesByIdAsync.rejected,
        updateBadgesByIdAsync.rejected,
        deleteBadgesByIdAsync.rejected
      ),
      (state, action) => {
        state.streakBadgesLoader = false;
      }
    );
  },
  reducers: {
    emptyStreakBadges: (state) => initialState,
  },
});

export const { emptyStreakBadges } = streakBadgesSlice.actions;

export default streakBadgesSlice.reducer;
